var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-22.89 -12 165.58 165.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.03,25.09l8.36-5.01C96.09,7.59,79.98,0,61.8,0,27.67,0,0,27.67,0,61.8c0,27.92,18.51,51.51,43.93,59.17v-62.84l-9.46,5.67v38.78c0,1.68-1.9,2.68-3.27,1.7-13.18-9.51-21.76-24.99-21.76-42.48,0-28.92,23.44-52.36,52.36-52.36,14.74,0,27.72,5.85,37.23,15.65Z",
    fill: "#f4f1ea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.34,122.88c3.08.47,6.24.72,9.46.72V47.41l-9.46,5.67v69.79Z",
    fill: "#f4f1ea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.59,83.21c-5.35,11.92-15.01,21.47-27.01,26.66-1.37.59-2.91-.41-2.91-1.9V36.7l-9.46,5.67v99.2h9.46v-20.6c18.57-5.59,33.43-19.68,40.11-37.76h-10.19Z",
    fill: "#f4f1ea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDark);
export default __webpack_public_path__ + "static/media/icon-dark.2c70b7b466ed5a5963c46ef80c78e432.svg";
export { ForwardRef as ReactComponent };